import { render, staticRenderFns } from "./freeCreditTab.vue?vue&type=template&id=85013bb4&lang=pug"
import script from "./freeCreditTab.vue?vue&type=script&lang=js"
export * from "./freeCreditTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports